import SearchOverlay from "@components/search-overlay/search-overlay";
import { gsap } from "gsap";
import ScrollToPlugin from "gsap/ScrollToPlugin";

gsap.registerPlugin(ScrollToPlugin);

export default class GlobalService {
  static lastScroll = window.pageYOffset;

  static smoothScrollSupported =
    "scrollBehavior" in document.documentElement.style;

  static initialized = false;

  static init() {
    if (!this.initialized) {
      this.initialized = true;
      this.checkScrollBehavior();
    }
  }

  static get searchOverlay() {
    return SearchOverlay.getInstances()[0];
  }

  static toggleSearchOverlay(willShow = null) {
    // If willShow is given
    if (typeof willShow === "boolean") {
      if (willShow) {
        this.searchOverlay.show();
      } else {
        this.searchOverlay.hide();
      }
    } else {
      // Toggle
      /* eslint-disable-next-line no-lonely-if */
      if (this.searchOverlay.visible) {
        this.searchOverlay.hide();
      } else {
        this.searchOverlay.show();
      }
    }
  }

  static preventScroll() {
    this.lastScroll = window.pageYOffset;

    document.body.style.setProperty(
      "--fixed-body-scroll",
      `${-this.lastScroll}px`
    );
    document.body.classList.add("no-scroll");
  }

  static allowScroll() {
    document.body.classList.remove("no-scroll");
  }

  static checkScrollBehavior() {
    if (!this.smoothScrollSupported) {
      // Use custom smooth scroll when not supported natively
      document.addEventListener("touchstart", this.stopCustomScroll.bind(this));
      document.addEventListener("mousewheel", this.stopCustomScroll.bind(this));
    }
  }

  static scrollTo(scrollTop) {
    // Use native smooth scroll if supported
    if (this.smoothScrollSupported) {
      window.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    }
    // Improvise smooth scroll if not supported
    else {
      this.customScrollTo(scrollTop);
    }
  }

  static stopCustomScroll() {
    if (this.scrollAnimationTimeline) {
      this.scrollAnimationTimeline.kill();
    }
  }

  static customScrollTo(scrollTo) {
    if (this.scrollAnimationTimeline) {
      this.scrollAnimationTimeline.kill();
    }

    this.scrollAnimationTimeline = gsap.to(window, 1, { scrollTo });
  }
}

GlobalService.init();
